// general
export const SOURCE_CODE_URL = "https://github.com/Fe-56/portfolio";
export const WEBSITE_PATH = "/portfolio/#/";
export const ABOUT_PATH = "/";
export const PROJECTS_PATH = "/projects";
export const SKILLS_PATH = "/skills";
export const EXPERIENCES_PATH = "/experiences";
export const HOBBIES_PATH = "/hobbies";
export const CONTACT_PATH = "/contact";
export const WEBSITE_PIC = "http://fe-56.github.io/portfolio/favicon.ico?v=2";

// About page
export const ABOUT_RESUME_URL =
  "https://drive.google.com/file/d/1mGziGHzYYVCoDxOAJUGq5TEobrj_SiP2/view?usp=sharing";
export const ABOUT_GITHUB_URL = "https://github.com/Fe-56";
export const ABOUT_LINKEDIN_URL = "https://www.linkedin.com/in/limfuoen/";

// Projects page
export const PROJECTS_ANNAMALAI_COURSE_URL =
  "https://www.sutd.edu.sg/course/50-021-artificial-intelligence/";
export const PROJECTS_ANNAMALAI_GITHUB_URL =
  "https://github.com/Fe-56/ai_project_ser";
export const PROJECTS_ANNAMALAI_CLOUDSINE_AWARD_URL =
  "https://www.sutd.edu.sg/campus-life/student-life/student-awards/student-academic-awards/cloudsine-artificial-intelligence-award/";
export const PROJECTS_ANNAMALAI_POSTER_URL =
  "https://drive.google.com/file/d/15AfxqxXqw4u6RK2q8oAQOLRwKHItIb7j/view?usp=sharing";
export const PROJECTS_PROSPERO_PROJECT_URL =
  "https://capstoneshowcase.sutd.edu.sg/project/proj-s16-htx_devt-of-contacess-lie-detectn/";
export const PROJECTS_DEFUND_PROJECT_URL = "https://de-fund.vercel.app/";
export const PROJECTS_DEFUND_COURSE_URL =
  "https://www.sutd.edu.sg/course/50-037-blockchain-technology";
export const PROJECTS_DEFUND_GITHUB_URL = "https://github.com/abramtan/DeFund";
export const PROJECTS_MUSIC_RECOMMENDATION_COURSE_URL =
  "https://istd.sutd.edu.sg/undergraduate/courses/50038-computational-data-science/";
export const PROJECTS_MUSIC_RECOMMENDATION_GITHUB_URL =
  "https://github.com/Fe-56/CDeeS";
export const PROJECTS_ONLINE_HATE_SPEECH_DETECTION_COURSE_URL =
  "https://istd.sutd.edu.sg/undergraduate/courses/50007-machine-learning/";
export const PROJECTS_ONLINE_HATE_SPEECH_DETECTION_GITHUB_URL =
  "https://github.com/waishun78/hate-speech-classification";
export const PROJECTS_ONLINE_HATE_SPEECH_DETECTION_PROJECT_URL =
  "https://www.kaggle.com/competitions/50007-2022";
export const PROJECTS_TRANSFERCONNECT_COURSE_URL =
  "https://istd.sutd.edu.sg/undergraduate/courses/50003-elements-of-software-construction";
export const PROJECTS_GIGLET_COURSE_URL =
  "https://epd.sutd.edu.sg/undergraduate-courses/30111-entrepreneurship/";
export const PROJECTS_WORDLE_COURSE_URL =
  "https://istd.sutd.edu.sg/undergraduate/courses/50002-computation-structures/";
export const PROJECTS_WORDLE_URL =
  "https://www.nytimes.com/games/wordle/index.html";
export const PROJECTS_WORDLE_PROJECT_URL =
  "https://istd.sutd.edu.sg/term4-design-exhibition/50002/wordle";
export const PROJECTS_WORDLE_GITHUB_URL = "https://github.com/rphly/wordle";
export const PROJECTS_FEAST_COURSE_URL =
  "https://istd.sutd.edu.sg/undergraduate/courses/50001-information-systems-programming";
export const PROJECTS_FEAST_PROJECT_URL =
  "https://istd.sutd.edu.sg/term4-design-exhibition/50001/food-establishment-autonomous-spatial-tracking-feast";
export const PROJECTS_WILL_I_GO_BROKE_GITHUB_URL =
  "https://github.com/Fe-56/Will-I-Go-Broke";
export const PROJECTS_POKEMON_BATTLE_COURSE_URL =
  "https://smt.sutd.edu.sg/education/undergraduate/courses/10014-computational-thinking-for-design/";
export const PROJECTS_POKEMON_BATTLE_URL =
  "https://www.pokemon.com/us/pokemon-video-games/all-pokemon-games/";
export const PROJECTS_POKEMON_BATTLE_GITHUB_URL =
  "https://github.com/Fe-56/Pokemon-Battle";

// Skills page
export const SKILLS_CERTIFICATIONS_RESPONSIVE_URL =
  "https://www.freecodecamp.org/certification/Fe-56/responsive-web-design";
export const SKILLS_CERTIFICATIONS_JAVASCRIPT_URL =
  "https://www.freecodecamp.org/certification/Fe-56/javascript-algorithms-and-data-structures";
export const SKILLS_CERTIFICATIONS_FRONTEND_URL =
  "https://www.freecodecamp.org/certification/Fe-56/front-end-development-libraries";
export const SKILLS_CERTIFICATIONS_VISUALISATION_URL =
  "https://www.freecodecamp.org/certification/Fe-56/data-visualization";
export const SKILLS_CERTIFICATIONS_BACKEND_URL =
  "https://www.freecodecamp.org/certification/Fe-56/back-end-development-and-apis";
export const SKILLS_CERTIFICATIONS_SCIENTIFIC_URL =
  "https://www.freecodecamp.org/certification/Fe-56/scientific-computing-with-python-v7";
export const SKILLS_CERTIFICATIONS_DATA_URL =
  "https://www.freecodecamp.org/certification/Fe-56/data-analysis-with-python-v7";

// Experiences page

// Hobbies page
export const HOBBIES_CYCLING_TREK_URL =
  "https://www.trekbikes.com/us/en_US/bikes/road-bikes/performance-road-bikes/1-series/1-2/p/15807/";
export const HOBBIES_CYCLING_BIANCHI_URL =
  "https://www.bianchi.com/bikes/bikes/road/racing-road/sprint/";
export const HOBBIES_RUNNING_CYCLING_STRAVA_URL =
  "https://www.strava.com/athletes/33035635";
export const HOBBIES_RUNNING_GARMIN_URL =
  "https://www.garmin.com.sg/news/press-release/news-2021-jun-forerunner55/";
export const HOBBIES_GUITAR_GUITAR_URL =
  "https://www.ibanez.com/na/products/detail/grgr131ex_2y_02.html";
export const HOBBIES_GUITAR_AMP_URL =
  "https://www.fender.com/en-US/guitar-amplifiers/contemporary-digital/champion-20/2330200000.html";
export const HOBBIES_GUITAR_LINKIN_PARK_URL =
  "https://en.wikipedia.org/wiki/Linkin_Park";
export const HOBBIES_GUITAR_METALLICA_URL =
  "https://en.wikipedia.org/wiki/Metallica";
export const HOBBIES_GUITAR_GREEN_DAY_URL =
  "https://en.wikipedia.org/wiki/Green_Day";
export const HOBBIES_GUITAR_LINKIN_PARK_PICTURE_URL =
  "https://townsquare.media/site/366/files/2014/03/Brad-Delson.jpg?w=980&q=75";
export const HOBBIES_GUITAR_METALLICA_PICTURE_URL =
  "https://cdn.mos.cms.futurecdn.net/rq8KkgPmJ3deSfWYPAUGrJ.jpg";
export const HOBBIES_GUITAR_GREEN_DAY_PICTURE_URL =
  "https://www.nme.com/wp-content/uploads/2016/09/2013GREENDAY_AB240813-1.jpg";
export const HOBBIES_GUITAR_SPOTIFY_URL =
  "https://open.spotify.com/user/j3bhg792iv70buez0dn81gbih";
export const HOBBIES_NETFLIX_DRAGON_BALL_URL =
  "https://en.wikipedia.org/wiki/Dragon_Ball";
export const HOBBIES_NETFLIX_NARUTO_URL =
  "https://en.wikipedia.org/wiki/Naruto";
export const HOBBIES_NETFLIX_VEGETA_URL =
  "https://dragonball.fandom.com/wiki/Vegeta";
export const HOBBIES_NETFLIX_ITACHI_URL =
  "https://naruto.fandom.com/wiki/Itachi_Uchiha";
export const HOBBIES_NETFLIX_VEGETA_PICTURE_URL =
  "https://i.redd.it/e6gr4jd1i5o81.jpg";
export const HOBBIES_NETFLIX_ITACHI_PICTURE_URL =
  "https://mfiles.alphacoders.com/900/900540.jpg";

// Contact page
export const CONTACT_EMAIL_URL = "mailto:limfuoen1999@gmail.com";
export const CONTACT_TELEGRAM_URL = "https://t.me/Fe_56";
export const CONTACT_PHONE_URL = "tel:+6597357695";
export const CONTACT_LOCATION_URL =
  "https://www.google.com/maps/place/Singapore/@1.3139946,103.6794481,11z/data=!4m6!3m5!1s0x31da11238a8b9375:0x887869cf52abf5c4!8m2!3d1.352083!4d103.819836!16zL20vMDZ0MnQ?entry=ttu";
